// Digital Marketing Skills organized by subcategories
export const DIGITAL_MARKETING_SKILLS_CATEGORIES = [
  {
    name: 'Search Engine Optimization',
    skills: [
      'Keyword Research', 'On-page SEO', 'Technical SEO',
      'Link Building', 'Content Optimization', 'SEO Analytics',
      'Local SEO', 'Mobile SEO', 'Voice Search Optimization',
      'SEO Strategy', 'Competitor Analysis', 'SEO Auditing',
      'Search Console', 'Rank Tracking', 'SEO Tools'
    ]
  },
  {
    name: 'Content Marketing',
    skills: [
      'Content Strategy', 'Content Creation', 'Content Planning',
      'Blog Writing', 'Copywriting', 'Content Distribution',
      'Content Analytics', 'Editorial Calendar', 'Content Management',
      'Content Optimization', 'Storytelling', 'Content Formats',
      'Content Tools', 'Content Promotion', 'Content ROI'
    ]
  },
  {
    name: 'Social Media Marketing',
    skills: [
      'Social Strategy', 'Community Management', 'Social Content',
      'Social Analytics', 'Social Advertising', 'Engagement Tactics',
      'Platform Management', 'Social Listening', 'Influencer Marketing',
      'Social Scheduling', 'Crisis Management', 'Social Tools',
      'Brand Voice', 'Social ROI', 'Social Trends'
    ]
  },
  {
    name: 'Email Marketing',
    skills: [
      'Email Strategy', 'Campaign Management', 'Email Design',
      'List Management', 'Email Analytics', 'A/B Testing',
      'Automation', 'Personalization', 'Deliverability',
      'Segmentation', 'Email Tools', 'Performance Tracking',
      'Email Compliance', 'Template Design', 'Email ROI'
    ]
  },
  {
    name: 'Paid Advertising',
    skills: [
      'PPC Management', 'Ad Copywriting', 'Campaign Strategy',
      'Budget Management', 'Bid Management', 'Ad Analytics',
      'Audience Targeting', 'Ad Platforms', 'Display Advertising',
      'Retargeting', 'Ad Testing', 'Performance Optimization',
      'Ad Tools', 'ROI Analysis', 'Cross-platform Advertising'
    ]
  },
  {
    name: 'Analytics and Data',
    skills: [
      'Web Analytics', 'Data Analysis', 'Performance Tracking',
      'Conversion Optimization', 'Attribution Modeling', 'Report Generation',
      'KPI Monitoring', 'Data Visualization', 'Analytics Tools',
      'Custom Reporting', 'Data Integration', 'Statistical Analysis',
      'Predictive Analytics', 'Data Strategy', 'ROI Measurement'
    ]
  },
  {
    name: 'Marketing Automation',
    skills: [
      'Automation Strategy', 'Workflow Design', 'Lead Nurturing',
      'Campaign Automation', 'Tool Management', 'Integration',
      'Personalization', 'Testing', 'Performance Monitoring',
      'Automation Analytics', 'Platform Management', 'Process Optimization',
      'Automation Tools', 'Workflow Analysis', 'Automation ROI'
    ]
  },
  {
    name: 'Video Marketing',
    skills: [
      'Video Strategy', 'Content Planning', 'Video Production',
      'Video Optimization', 'Platform Management', 'Video Analytics',
      'Live Streaming', 'Video SEO', 'Video Distribution',
      'Audience Engagement', 'Video Tools', 'Performance Tracking',
      'Video Advertising', 'Format Selection', 'Video ROI'
    ]
  },
  {
    name: 'Mobile Marketing',
    skills: [
      'Mobile Strategy', 'App Marketing', 'Mobile Advertising',
      'SMS Marketing', 'Mobile Analytics', 'App Store Optimization',
      'Mobile Content', 'Mobile UX', 'Mobile SEO',
      'Location Marketing', 'Mobile Tools', 'Performance Tracking',
      'Mobile Integration', 'Platform Management', 'Mobile ROI'
    ]
  },
  {
    name: 'Digital Strategy',
    skills: [
      'Strategic Planning', 'Channel Strategy', 'Campaign Planning',
      'Budget Management', 'Performance Strategy', 'Brand Strategy',
      'Market Analysis', 'Competitive Analysis', 'Target Audience',
      'Growth Strategy', 'Innovation Planning', 'Strategy Tools',
      'ROI Planning', 'Risk Management', 'Strategy Implementation'
    ]
  },
  {
    name: 'Conversion Optimization',
    skills: [
      'CRO Strategy', 'A/B Testing', 'Landing Pages',
      'User Experience', 'Analytics', 'Heat Mapping',
      'User Testing', 'Funnel Optimization', 'Form Optimization',
      'Page Speed', 'Mobile Optimization', 'Testing Tools',
      'Performance Analysis', 'Behavior Analysis', 'CRO Tools'
    ]
  },
  {
    name: 'Marketing Technology',
    skills: [
      'MarTech Stack', 'Tool Selection', 'Platform Integration',
      'Automation Tools', 'Analytics Tools', 'CRM Systems',
      'Content Tools', 'Social Tools', 'SEO Tools',
      'Email Platforms', 'Testing Tools', 'Reporting Tools',
      'Data Tools', 'Integration Tools', 'Technology ROI'
    ]
  }
];

// Export flattened list for backward compatibility
export const DIGITAL_MARKETING_SKILLS = DIGITAL_MARKETING_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
